import { buildMiniAppUrl, buildReelStartParam, openTelegramLink, shareToTelegramStory } from '../../utils/telegram';

const getEntityId = entity => entity?._id || entity?.id || null;

export const buildThreadedComments = (comments, repliesByCommentId, user) => {
  const currentUserId = getEntityId(user);
  const toCommentViewModel = comment => {
    const commentId = getEntityId(comment);
    const commentUser = comment.user || {};
    const commentUserId = getEntityId(commentUser);

    if (!commentId) {
      return null;
    }

    return {
      id: commentId,
      userId: commentUserId,
      parentCommentId: getEntityId(comment.parentComment) || comment.parentComment || null,
      text: comment.text || '',
      likesCount: comment.likesCount ?? 0,
      repliesCount: comment.repliesCount ?? 0,
      liked: Boolean(comment.liked),
      likePending: Boolean(comment.likePending),
      canDelete: Boolean(currentUserId && currentUserId === commentUserId),
      status: (comment.status || 'ACTIVE').toLowerCase(),
      createdAt: comment.createdAt || null,
      user: {
        name: commentUser.name || commentUser.username || 'User',
        username: commentUser.username || '',
        avatar: commentUser.profilePhoto || commentUser.avatar || '',
      },
    };
  };

  return comments
    .map(toCommentViewModel)
    .filter(Boolean)
    .map(comment => {
      const repliesInfo = repliesByCommentId[comment.id];
      const replies = (repliesInfo?.data || []).map(toCommentViewModel).filter(Boolean);

      return {
        ...comment,
        replies,
        repliesLoaded: Boolean(repliesInfo?.loaded),
        repliesHasMore: Boolean(repliesInfo?.hasMore),
        repliesNextCursor: repliesInfo?.nextCursor || null,
        repliesPending: Boolean(repliesInfo?.pending),
        repliesFetchMorePending: Boolean(repliesInfo?.fetchMorePending),
      };
    });
};

export const shareToPlatform = async (platform, shareUrl, shareText, reelName, storyMediaUrl) => {
  if (platform === 'copy_link') {
    await navigator.clipboard.writeText(shareUrl);
    return true;
  }

  if (platform === 'telegram') {
    openTelegramLink(
      `https://t.me/share/url?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`,
    );
    return false;
  }

  if (platform === 'repost') {
    const didOpenStoryShare = shareToTelegramStory(storyMediaUrl, {
      text: shareText || reelName || '',
      widget_link: {
        url: shareUrl,
        name: reelName || 'Open reel',
      },
    });

    if (didOpenStoryShare) {
      return false;
    }
  }

  if (navigator.share) {
    await navigator.share({ title: reelName, text: shareText, url: shareUrl });
    return false;
  }

  await navigator.clipboard.writeText(shareUrl);
  return true;
};

export const buildReelShareUrl = reelId => {
  return buildMiniAppUrl(buildReelStartParam(reelId));
};
